module.exports = "module.exports = __webpack_public_path__ + \"static/media/Drill_Sgt_Creed4-4.e5b42590.svg\";";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./src/content/figures/Drill_Sgt_Creed4-4.svg
// module id = 1355
// module chunks = 0